<template>
  <div class="card cursor-pointer"
    :class="getCardClass" @click.prevent="navigateToTask">
    <div class="flex justify-between">
      <h3>{{ type }}</h3>
      <div>
        <font-awesome-icon class="text-2xl lg:text-3xl"
            :class="progressIconStyle" :icon="statusIcon"/>
      </div>
    </div>
    <!--div class="mb-2">
      <h4 v-if="task.name">{{ task.name ?? '' }}</h4>
      <p v-if="task.description">{{ task.description ?? '' }}</p>
    </div-->
    <div class="text-base">
      <p class="text-black mb-3">
        {{ $t(`TaskComponent.${status.dateHeadline}`) }}</p>
      <div class="flex flex-row my-1 mx-0 p-3 items-center h-9 w-max rounded-md
        bg-[var(--color-orange)]" :style="dateStyle">
        <font-awesome-icon class="flex p-1 w-8 text-[var(--color-white)]" icon="fa-calendar"/>
        <p class="p-1 w-full text-[var(--color-white)]">{{ status.dateToShow }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import AssessmentHelper from '@/helpers/AssessmentHelper';

export default {
  name: 'TaskComponent',
  props: ['task'],
  computed: {
    // eslint-disable-next-line consistent-return
    type() {
      let returnString = '';
      if (this.task.assessmentRepresentationProperties) {
        if (this.task.assessmentRepresentationProperties.assessmentName) {
          // eslint-disable-next-line max-len
          returnString = this.task.assessmentRepresentationProperties.assessmentName[this.$i18n.locale];
        }
      } else {
        // maps type to the right translation
        returnString = this.task.name || '';
      }
      return returnString;
    },
    status() {
      return AssessmentHelper.evaluateStatus(this.task);
    },
    getCardClass() {
      if (this.status.status === 'inactive') {
        return 'disable-click card-inactive';
      }
      return '';
    },
    progressIconStyle() {
      switch (this.task.status) {
        case 'began':
          return 'icon-style-began';
        case 'open':
        case 'expired':
          return 'icon-style-open-expired';
        case 'submitted':
          return 'icon-style-submitted';
        default:
          return 'icon-style-open-expired';
      }
    },
    statusIcon() {
      switch (this.task.status) {
        case 'began':
          return 'fa-circle-half-stroke';
        case 'open':
        case 'expired':
          return 'fa-circle-notch';
        case 'submitted':
          return 'fa-circle-check';
        default:
          return 'fa-circle-notch';
      }
    },
    dateStyle() {
      if (this.status.status === 'active') {
        return 'color: var(--color-orange);';
      }
      return 'background: var(--color-inactive-dark);';
    },
  },
  methods: {
    navigateToTask() {
      if (this.status.status === 'inactive') return;

      const id = this.task._id;
      const showIntro = this.task.displayIntroPage === true;

      if (showIntro) {
        this.$router.push(`/assessment-intro?id=${id}`);
      } else {
        this.$router.push(`/questionnaire?id=${this.task._id}`);
      }
    },
  },
};
</script>

<style scoped>

.disable-click {
  pointer-events: none;
}

.icon-style-open-expired {
  color: var(--color-disabled)
}

.icon-style-began {
  color: var(--color-yellow-orange);
}

.icon-style-submitted {
  color: var(--color-orange);
}
</style>
